import {
  getAccessoryTypeBySlug,
  getProductTypeBySlug,
} from "@/lib/generated/product-types";
import { formatCityName } from "@/lib/formatting/geography";
import { getStateNameFromCode } from "@shared/formats/state";
import type { ListingIntentFilter } from "./context/listing-browse-types";

export interface ResultsHeadingInput {
  productType: string | null;
  intentFilter: ListingIntentFilter;
  city?: string;
  stateAbbr?: string;
  stateCode?: string | null;
}

const DEFAULT_HEADING = "Used packaging marketplace";

function formatPlace(city?: string, stateAbbr?: string, stateCode?: string | null): string {
  if (city && stateAbbr) return `${formatCityName(city, stateAbbr)}, ${stateAbbr}`;
  if (stateAbbr) return stateAbbr;
  if (stateCode) return getStateNameFromCode(stateCode) ?? stateCode.toUpperCase();
  return "";
}

export function buildResultsHeading({
  productType,
  intentFilter,
  city,
  stateAbbr,
  stateCode,
}: ResultsHeadingInput): string {
  const displayName = productType
    ? (getProductTypeBySlug(productType) ?? getAccessoryTypeBySlug(productType))
        ?.pluralDisplayName
    : null;
  const productLabel = displayName ? `Used ${displayName}` : "Used packaging";
  const place = formatPlace(city, stateAbbr, stateCode);
  const where = place ? ` in ${place}` : "";

  if (intentFilter === "recycle") {
    return `${productLabel} available for free pickup${where}`;
  }
  if (!productType && !where) return DEFAULT_HEADING;
  return `${productLabel}${where}`;
}
